import React, { useState } from "react";
import {
    Collapse,
    Box,
    CircularProgress,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { formatTZDate } from 'state/helpers';

const DrillDownTable = ({ data = [], type, onRowClick }) => {
    const [openRow, setOpenRow] = useState(null);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    const getRowKey = (row) =>
        type === "crew" ? row.crewCode : row.user;

    const handleRowClick = async (row) => {
        const key = getRowKey(row);

        if (openRow === key) {
            setOpenRow(null);
            return;
        }

        setOpenRow(key);
        setLoading(true);

        const res = await onRowClick(row);
        setLogs(res || []);
        setLoading(false);
    };

    if (!data.length) return null;

    return (
        <TableContainer sx={{ maxHeight: "65vh" }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>#</TableCell>
                        <TableCell>{type === "crew" ? "Crew" : "User"}</TableCell>
                        <TableCell align="right">Logs</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data?.map((row, idx) => (
                        <React.Fragment key={getRowKey(row)}>
                            <TableRow
                                hover
                                onClick={() => handleRowClick(row)}
                                sx={{ cursor: "pointer" }}
                            >
                                <TableCell>{idx + 1}</TableCell>

                                {type === "crew" ? (
                                    <TableCell>
                                        <Typography fontWeight={500}>
                                            {row.crewCode} | {row.rank} | {row.base}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {row.crewName}
                                        </Typography>
                                    </TableCell>
                                ) : (
                                    <TableCell>
                                        <Typography fontWeight={500}>{row.user}</Typography>
                                    </TableCell>
                                )}

                                <TableCell align="right">{row.count}</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={3} sx={{ p: 0 }}>
                                    <Collapse
                                        in={openRow === getRowKey(row)}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <Box px={1}>
                                            {loading ? (
                                                <CircularProgress size={20} />
                                            ) : (
                                                <TableContainer
                                                    variant="outlined"
                                                    sx={{ backgroundColor: "transparent" }}
                                                >
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell width={80}>Date</TableCell>
                                                                <TableCell width={128}>Log Time</TableCell>
                                                                <TableCell>Message</TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            {logs?.map((log) => (
                                                                <TableRow key={log._id} hover>
                                                                    <TableCell>
                                                                        {formatTZDate(log.logForDay)}
                                                                    </TableCell>

                                                                    <TableCell>
                                                                        {formatTZDate(log.logOnDayTime, "UTC", "HH:mm dd/MM/yyyy")}
                                                                    </TableCell>

                                                                    <TableCell sx={{ whiteSpace: "normal" }}>
                                                                        {log.logMessage}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </Box>
                                    </Collapse>
                                </TableCell>
                            </TableRow>
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};


export default DrillDownTable;
